(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('AgendaAppointmentRecurrenceUpdateController', ['$uibModalInstance', 'RecurrenceUpdateMethod', AgendaAppointmentRecurrenceUpdateControllerFn]);

    /* recurrence update controller */
    function AgendaAppointmentRecurrenceUpdateControllerFn($uibModalInstance, RecurrenceUpdateMethod) {
        /* jshint validthis:true */
        var vm = this;
        vm.updateMethod = null;
        vm.updateMethods = [];

        vm.save = function () {
            $uibModalInstance.close(vm.updateMethod);
        };

        activate();

        /* load work */
        function activate() {
            vm.updateMethods.push(RecurrenceUpdateMethod.Selected);
            vm.updateMethods.push(RecurrenceUpdateMethod.Future);

            // set default value
            vm.updateMethod = RecurrenceUpdateMethod.Future.value;
        }
    }
})();
